// src/components/users/CreateUserModal.js
import React from "react";
import { Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import CreateOrUpdateUserForm from "../../forms/CreateOrUpdateUserForm";

const CreateUserModal = ({ open, onClose, userInfo, loading, error }) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="Register New User"
      width="md"
    >
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <CreateOrUpdateUserForm
        loading={loading}
        onSuccess={onClose}
        userInfo={userInfo}
      />
    </AppModal>
  );
};
export default CreateUserModal;
